<template>
    <div class="w-full text-black">
        <div class="flex items-center justify-between pb-[18px] border-b">
            <div>
                <h2 class="text-[20px] font-light">Information Personnelle</h2>
                <p class="text-[13px] font-extralight mt-2">Mettre à jour les détails de votre profil</p>
            </div>
            <div class="flex items-center gap-x-[6px] font-light">
                <button class="h-[40px] border rounded-xl px-6">Annuler</button>
                <button v-on:click="updateEmploye" class="h-[40px] px-6 border border-[#3c41e9] bg-[#3c41e9] text-white rounded-xl">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Sauvegarder</span>
                </button>
            </div>
        </div>
        <div class="py-[18px] flex items-start">
            <label for="photo" class="font-light w-[200px]">Votre photo</label>
            <div class="grow flex items-center gap-x-[12px]">
                <div class="size-[46px] rounded-full border flex items-center justify-center">
                    <User :size="20" strokeWidth="1.4"/>
                </div>
                <button class="h-[38px] border rounded-xl px-6">Ajouter photo</button>
                <p class="font-extralight text-[13px]">JPG ou PNG. 4MB max</p>
            </div>
        </div>
        <div class="flex items-start">
            <label for="photo" class="font-light w-[200px] pt-[18px]">Nom</label>
            <div class="grow py-[18px] border-t border-b">
                <input type="text" v-model="form.first_name" placeholder="John Doe" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="py-[18px] flex items-start">
            <label for="photo" class="font-light w-[200px]">Prenom</label>
            <div class="grow">
                <input type="text" v-model="form.last_name" placeholder="Franck" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="flex items-start">
            <label for="photo" class="font-light w-[200px] pt-[18px]">Contact</label>
            <div class="grow py-[18px] border-t border-b">
                <input type="tel" v-model="form.phone" placeholder="(+XXX) XX XX XX XX XX" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="py-[18px] flex items-start">
            <label for="photo" class="font-light w-[200px]">Contact urgence</label>
            <div class="grow">
                <input type="tel" v-model="form.emergency_phone" placeholder="(+XXX) XX XX XX XX XX" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="flex items-start">
            <label for="photo" class="font-light w-[200px] pt-[18px]">Situation matrimonial</label>
            <div class="grow py-[18px] border-t">
                <select v-model="form.marital_status" name="sitmat" id="sitmat" class="border font-extralight rounded-xl px-6 w-full h-[40px] focus:outline-none">
                    <option value="">Choisissez le status</option>
                    <option value="celibataire">Célibataire</option>
                    <option value="marie">Marié</option>
                    <option value="veuve">Veuve</option>
                    <option value="divorce">Divorcé</option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
import {User,Loader2} from "lucide-vue-next";
import Swal from "sweetalert2";
import API from "@/service/API";
export default {
    name: "UserProfil",
    components:{
        User,Loader2
    },
    props:["user"],
    mounted(){
        const {first_name,last_name,phone,emergency_phone,marital_status,image} = this.user;
        this.form = {first_name,last_name,phone,emergency_phone,image,marital_status};
    },
    data(){
        return {
            form:{},
            asSend:false
        }
    },
    methods:{
        updateEmploye(){
            const userId = localStorage.getItem("userId");
            this.asSend = true;
            API.post('updateEmployee/' + userId,{...this.form})
            .then((res)=>{
                if(res.data.status){
                //   this.getUsersInfo(this.id);
                  Swal.fire('Succès!!!!',"Infomation mis à jour",'succes')
                }
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.asSend = false;})
        },
    }
}
</script>